<template>
  <div class="container">
    <div class="row pt-5">
      <div class="col">
        <div class="row pt-2">
          <div class="col">
            <nav>
              <ol class="breadcrumb">
                <li class="breadcrumb-item mx-3"><router-link  to="/">الرئيسية</router-link></li>
                <i class="fa-solid fa-chevron-left pt-1"></i>
                <li class="breadcrumb-item active mx-3 almarai-bold" aria-current="page">بطاقاتي</li>
              </ol>
            </nav>
          </div>
        </div>
        <errorAlert v-if="hasError" :alertMessage="message" />
        <mainloader v-if="loader" />
        <div v-else class="row pt-3">
          <h5 class="almarai-bold py-3">بطاقاتي</h5>
          <div class="col-12 mb-2" v-for="(row,index) in rows" :key="index">
            <div class="form-check input-style position-R">
              <label class="form-check-label" for="radioDefault1">
                  <input class="form-check-input hidden-fileds" type="radio" name="radioDefault" id="radioDefault1">
                    <span class="mx-2">{{row.last}}</span>
                    <span class="vertical-sub">**** **** ****</span>
              </label>
              <span class="card-delete mouse-hand" @click="deleteImg(row.id, index)">
                <i class="bi bi-trash3 red-color"></i>
              </span>
            </div>
          </div>
          <div v-if="!rows.length" class="col">
            <div class="text-center pb-3">
              <img src="/assets/images/icons/Frame-408.png" class="img-fluid" alt="">
            </div>
            <div class="almarai-regular pt-2 text-center">انت لم تقم بحفظ اي بطاقة حتى الان</div>
            <div class="text-center almarai-regular gray-color fonttext-14">
              <span>احفظ بطاقاتك بكل امان للدفع بكل سهولة من تطبيقنا </span>
            </div>
          </div>
        </div>
        <div class="row py-4 justify-content-center">
          <div class="col-8 text-center py-3">
            <router-link to="/addpaymentcard">
              <button class="submit-button form-control almarai-bold">اضافة بطاقة جديدة</button>
            </router-link>
          </div>  
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'paymentcards',
  data(){
    return {
      hasError: false,
      message: "",
      loader: true,
      rows: [],
    }
  },
  methods:{
    paymentMethodList(){
      this.hasError = false;
      this.$http.get('/api/payments/methodsList').then(res => {
        // console.log(res);
        this.rows = res.data.paymentMethods;
        this.loader = false;
        window.scroll(0,0);
      }).catch(err => {
        // console.log(err);
        this.loader = false;
        this.message = this.$globalError(err);
        this.hasError = true;
        window.scroll(0,0);
      });
    },
    deleteImg(id,index){
      swal({
        title: "هل تريد تأكيد حذف البطاقة ؟",
        // text: "You will not be able to recover this imaginary file!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        closeOnConfirm: false
      },()=> this.deleteMedia(id, index));
    },
    deleteMedia(id,index){
      this.$http.delete("/api/payments/delete/"+id).then(res => {
        this.rows.splice(index, 1);
        swal("تم حذف البطاقة بنجاح");
      })
    },
  },
  created(){
    this.paymentMethodList();
  }
}
</script>